import React from 'react';
import classNames from 'classnames';

export interface RadioGroupItem<T> {
  value: T;
  label: string | JSX.Element;
  disabled?: boolean;
}

export type RadioGroupItemAlignmentType = 'vertical' | 'horizontal';

interface RadiopGroupPropsInterface<T> {
  name: string;
  options: RadioGroupItem<T>[];
  alignment?: RadioGroupItemAlignmentType;
  darkMode?: boolean;
  value: string;
  onChange: (item: RadioGroupItem<T>) => void;
  className?: string;
  itemClassName?: string;
  cyanMode?: boolean;
}

export const RadioGroup = <T,>({
  name,
  options,
  value,
  onChange,
  className,
  itemClassName,
  alignment = 'vertical',
  darkMode = false,
  cyanMode = false
}: RadiopGroupPropsInterface<T>) => {
  return (
    <ul
      className={classNames('flex', className, alignment === 'vertical' ? 'flex-col space-y-2' : 'flex-row space-x-2')}
    >
      {options.map((option, index) => {
        const isOptionSelected = value === `${option.value}`;
        return (
          <li
            key={`${index}-option`}
            className={classNames(
              itemClassName || 'flex items-center text-bedrock-p-strong space-x-2',
              option.disabled ? 'opacity-40 cursor-not-allowed' : 'hover:opacity-80 cursor-pointer'
            )}
            onClick={() => {
              if (!option.disabled) {
                onChange(option);
              }
            }}
          >
            <input
              readOnly
              type='radio'
              name={name}
              disabled={option.disabled}
              value={`${option.value}`}
              checked={isOptionSelected}
              className={classNames(
                'transition-all border-2 focus:ring-0 checked:radio-group-active disabled:cursor-not-allowed',
                !option.disabled && 'cursor-pointer',
                isOptionSelected ? (cyanMode ? 'text-[rgb(var(--neue-journey-accent))] border-[rgb(var(--neue-journey-accent))]' : 'text-journey-primary-blue border-journey-primary-blue') : 'text-bedrock-white border-bedrock-gray-medium'
              )}
            />
            <label htmlFor={name} className={classNames(!option.disabled ? 'cursor-pointer' : 'cursor-not-allowed')}>
              <div className={classNames('text-bedrock-p', darkMode ? 'text-bedrock-white' : 'text-bedrock-black')}>{option.label}</div>
            </label>
          </li>
        );
      })}
    </ul>
  );
};